
import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import {Popover, PopoverAnimationVertical} from 'material-ui/Popover';
import IconButton from 'material-ui/IconButton';
import AvSkipPrevious from 'material-ui/svg-icons/av/skip-previous';
import AvPause from 'material-ui/svg-icons/av/pause';
import AvPlayArrow from 'material-ui/svg-icons/av/play-arrow';
import AvSkipNext from 'material-ui/svg-icons/av/skip-next';
import Slider from 'material-ui/Slider';
import Badge from 'material-ui/Badge';
import AvQueueMusic from 'material-ui/svg-icons/av/queue-music';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';
import AvPlayListAdd from 'material-ui/svg-icons/av/playlist-add';
import AvVolumeUp from 'material-ui/svg-icons/av/volume-up';
import AvVolumeMute from 'material-ui/svg-icons/av/volume-mute';
import {List, ListItem} from 'material-ui/List';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import AvPlayCircleOutline from 'material-ui/svg-icons/av/play-circle-outline';
import NavigationMoreVert from 'material-ui/svg-icons/navigation/more-vert';
import ContentLink from 'material-ui/svg-icons/content/link';
import Common from './Common';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share';

const {
  FacebookShareButton
} = ShareButtons;

var QRCode = require('qrcode.react');
const FacebookIcon = generateShareIcon('facebook');

const styles = {
  smallIcon: {
    width: 30,
    height: 30,
    fill:'#4e4e4e'
  },
  smallIconSel: {
    width: 30,
    height: 30,
    fill:'#FF9800'
  },
  small: {
    width: 40,
    height: 40,
    padding: 5,
    fill:'#4e4e4e'
  },
  specialIcon: {
    width: 48,
    height: 48,
    fill:'#4e4e4e'
  },
  special: {
    width: 68,
    height: 68,
    padding: 10,
    fill:'#4e4e4e'
  },
  mediumIcon: {
    width: 48,
    height: 48,
    fill:'#4e4e4e'
  },
  medium: {
    width: 54,
    height: 54,
    padding: 4,
    fill:'#4e4e4e'
  },
  largeIcon: {
    width: 60,
    height: 60,
    fill:'#4e4e4e'
  },
  large: {
    width: 68,
    height: 68,
    padding: 4,
    fill:'#4e4e4e'
  },
};

class MediaControl extends Component {

  constructor(props) {
    super(props);
    this.state = {
      playListIdx: -1,
      mp3PlayingObj: null,
      title: '',
      currentTime: '00:00',
      durationTime: '00:00',
      mediaPlaying: false,
      startLoading: false,
      progress: 0,
      openQueue: false,
      adjustVolume: false,
      actionMenu: false,
      volume: 1
    };
    this.props.parent.mediaControl = this;
    this.audio = new Audio();
    this.audio.volume = 1;
    this.audio.addEventListener('playing', this.audioPlaying.bind(this));
    this.audio.addEventListener('ended', this.audioEnd.bind(this));
    this.countUserListen = 0;
  }

  audioPlaying() {
    if (this.audio.duration > 0) {
      if (this.playingInterval)
        clearInterval(this.playingInterval);
      this.setState({
        durationTime: this.convertSecondToHour(this.audio.duration)
      });
      this.playingInterval = setInterval(this.audioProgress.bind(this), 1000);
    }
  }

  audioEnd(event) {
    clearInterval(this.playingInterval);
    this.props.parent.mainToolbar.setSpinLogo(false);
    if (this.state.mediaPlaying) {
      this.audio.pause();
    }
    if (this.state.playListIdx === -1) {
      this.setState({
        mp3PlayingObj: null,
        title: '',
        durationTime: '00:00',
        currentTime: '00:00',
        mediaPlaying: false,
        progress: 0
      });
    }
    else {
      this.playMp3ByPlayListIdx(this.state.playListIdx + 1);
    }
  }

  audioProgress() {
    if (this.audio.currentTime > 0 && !this.audio.paused) {
      if (this.state.startLoading) {
        this.setState({
          mediaPlaying: true,
          title: this.state.mp3PlayingObj.title,
          startLoading: false
        });
        var noteIdx = null;
        if (this.offset) {
          noteIdx = this.noteIdx;
          this.audio.currentTime  = this.offset;
          this.offset = null;
          this.noteIdx = null;
        }
        this.countUserListen = 0;
        this.props.parent.mainToolbar.setSpinLogo(true);
        Common.sendPlayingStat(this.state.mp3PlayingObj._id, this.props.parent.mainToolbar.state.searchText, noteIdx);
      }
      else {
        this.countUserListen++;
        if (this.countUserListen ===  parseInt(this.audio.duration * 0.05, 10)) {
          Common.sendListenOverN(this.state.mp3PlayingObj._id, 5);
        }
        if (this.countUserListen ===  parseInt(this.audio.duration * 0.1, 10)) {
          Common.sendListenOverN(this.state.mp3PlayingObj._id, 10);
        }
        if (this.countUserListen ===  parseInt(this.audio.duration * 0.2, 10)) {
          Common.sendListenOverN(this.state.mp3PlayingObj._id, 20);
        }
        if (this.countUserListen ===  parseInt(this.audio.duration * 0.5, 10)) {
          Common.sendListenOverN(this.state.mp3PlayingObj._id, 50);
        }
        this.setState({
          currentTime: this.convertSecondToHour(this.audio.currentTime),
          progress: this.audio.currentTime / this.audio.duration * 100
        });
      }
    }
  }

  getPlayListArray() {
    var result = [];
    var playListKey = Object.keys(this.props.myPlayList);
    playListKey.forEach((id) => {
      result.push(this.props.myPlayList[id]);
    });
    result.sort(function(a, b){
      return a.timeToAddList > b.timeToAddList;
    });
    return result;
  }

  previousMp3() {
    if (this.state.playListIdx !== -1) {
      this.playMp3ByPlayListIdx(--this.state.playListIdx);
    }
  }

  playMp3ByPlayListIdx(idx) {
    if (idx < 0) {
      idx = Object.keys(this.props.myPlayList).length - 1;
    }
    else {
      idx = idx % Object.keys(this.props.myPlayList).length;
    }
    var playList = this.getPlayListArray();
    this.playMp3FromPlayList(playList[idx], idx);
  }

  playMp3FromPlayList(mp3Obj, index) {
    this.playMedia(mp3Obj, index);
    this.closeQueue();
  }

  convertSecondToHour(totalSeconds) {
    totalSeconds = Math.floor(totalSeconds);
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    minutes = ('0' + minutes).slice(-2);
    seconds = ('0' + seconds).slice(-2);
    return minutes + ':' + seconds;
  }

  closeQueue() {
    this.setState({
      openQueue: false,
      adjustVolume: false,
      actionMenu: false
    });
  }

  playMedia(mp3Obj, index, offset, noteIdx) {
    var playListIdx = -1;
    if (index >= 0)
      playListIdx = index;

    this.setState({
      mp3PlayingObj: mp3Obj,
      title: Common.getTitleList()['loading']+' - ' + mp3Obj.title,
      durationTime: '00:00',
      currentTime: '00:00',
      mediaPlaying: false,
      startLoading: true,
      progress: 0,
      playListIdx: playListIdx
    });
    this.props.parent.mainToolbar.setSpinLogo(false);
    this.audio.src = mp3Obj.url;
    this.audio.play();
    this.props.parent.mediaRelation.loadRelationViewWithMediaObj(mp3Obj);
    if (offset) {
      this.offset = offset;
      this.noteIdx = noteIdx
    }
  }

  touchPPButton() {
    var self = this;
    if (this.state.mp3PlayingObj === null && self.queue) {
      self.playMedia(this.queue);
      setTimeout(() => {
        delete self.queue;
      }, 300);
      return;
    }

    if (this.state.mp3PlayingObj === null || this.state.startLoading)
      return;
    if (this.state.mediaPlaying) {
      this.audio.pause();
      this.props.parent.mainToolbar.setSpinLogo(false);
    }
    else {
      this.props.parent.mainToolbar.setSpinLogo(true);
      this.audio.play();
    }
    this.setState({
      mediaPlaying: !this.state.mediaPlaying
    });
  }

  nextMp3() {
    if (this.state.playListIdx !== -1) {
      this.playMp3ByPlayListIdx(++this.state.playListIdx);
    }
  }

  changeSlider(event, value){
    this.slideValue = value;
  }

  changeSliderVol(event, value) {
    this.slideVolValue = value;
  }

  stopSliderVol(event) {
    this.setState({
      volume: this.slideVolValue
    });
    if (!isNaN(this.slideVolValue))
      this.audio.volume = this.slideVolValue;
  }

  stopSlider(event) {
    if (this.audio && !this.audio.paused) {
      this.setState({
        progress: this.slideValue * 100
      });
      this.audio.currentTime = this.audio.duration * this.slideValue;
    }
  }

  touchShowPlayList(event) {
    event.preventDefault();
    if (!this.state.openQueue) {
      this.setState({
        openQueue: true,
        adjustVolume: false,
        actionMenu: false,
        anchorEl: event.currentTarget
      });
    }
    else {
      this.setState({
        openQueue: false
      });
    }
  }

  touchShowAdjustVolume(event) {
    event.preventDefault();
    if (!this.state.adjustVolume) {
      this.setState({
        openQueue: false,
        adjustVolume: true,
        actionMenu: false,
        anchorElVol: event.currentTarget
      });
    }
    else {
      this.setState({
        adjustVolume: false
      });
    }
  }

  touchShowActionMenu(event) {
    event.preventDefault();
    if (!this.state.adjustVolume) {
      this.setState({
        openQueue: false,
        adjustVolume: false,
        actionMenu: true,
        anchorElAct: event.currentTarget
      });
    }
    else {
      this.setState({
        actionMenu: false
      });
    }
  }

  touchLike(mp3Id) {
    this.props.parent.touchLike(mp3Id);
  }

  touchAddPlaylist(mp3Obj) {
    this.props.parent.touchAddPlaylist(mp3Obj);
  }

  deletePlayList(id, idx) {
    var currentIndex = this.state.playListIdx;
    if (idx === currentIndex) {
      currentIndex = -1;
    }
    if (idx < currentIndex) {
      currentIndex -= 1;
    }
    this.setState({
      openQueue: false,
      playListIdx: currentIndex
    });
    this.props.parent.deletePlayList(id, idx);
  }

  copyLink(shareUrl) {
    this.props.parent.copyLink(shareUrl);
  }

  mobileOpenQR(mp3Obj, share) {
    this.setState({
      actionMenu: false
    });
    this.props.parent.openQRDialog(mp3Obj, share);
  }

  mediaViewMobile() {
    var playList = this.getPlayListArray();
    var playListSize = playList.length;
    var width = window.innerWidth;
    var shareUrl = '';
    // just new deploy
    if (this.state.mp3PlayingObj)
      shareUrl = window.location.hostname + 'index.html?q=' + this.state.mp3PlayingObj._id;
    return (
      <div style={{'position':'fixed', 'bottom':'0px', 'width':'100%', 'zIndex':1499, borderTop: '1px solid #f0ece6'}}>
        <Paper zDepth={0} transitionEnabled={false}>
          <table width="100%"><tbody><tr>
            <td width="40">
              <IconButton
                iconStyle={styles.smallIcon}
                style={styles.small}
                onTouchTap={this.touchPPButton.bind(this)}
              >
                { this.state.mediaPlaying ? <AvPause /> : <AvPlayArrow /> }
              </IconButton>
            </td>
            <td>
              <table style={{height:'20px', width:'100%', marginTop:-5}}><tbody>
              <tr>
                <td colSpan={2}><div style={{textOverflow: 'ellipsis', whiteSpace:'nowrap', overflow:'hidden', fontSize:13, maxWidth:(width-200)}}>&nbsp;&nbsp;&nbsp;{this.state.title}</div></td>
              </tr>
              <tr>
                <td><Slider defaultValue={0} value={this.state.progress / 100} onDragStop={(event) => this.stopSlider(event)} onChange={(event, value) => this.changeSlider(event, value)} style={{height:'10px', width:'auto', marginLeft:'15px', marginTop:'-18px', marginRight:'5px', marginBottom:'0px'}}/></td>
                <td width="60"><div style={{fontSize:10, marginBottom:'-20px'}}>{this.state.currentTime} / {this.state.durationTime}</div></td>
              </tr></tbody></table>
            </td>
            <td width="150">
              {
                this.state.volume !== 0 ?
                <IconButton
                  iconStyle={styles.smallIcon}
                  onTouchTap={this.touchShowAdjustVolume.bind(this)}
                >
                  <AvVolumeUp />
                </IconButton> :
                <IconButton
                  iconStyle={styles.smallIcon}
                  onTouchTap={this.touchShowAdjustVolume.bind(this)}
                >
                  <AvVolumeMute />
                </IconButton>
              }
              {
                playListSize !== 0 ?
                <Badge
                  badgeContent={playListSize}
                  badgeStyle={{fontSize: 10, backgroundColor:'#FF9800', color:'#FFF'}}
                  style={{position:'absolute', marginLeft:25, marginTop:-5}}
                /> :
                <span></span>
              }
              <IconButton
                iconStyle={this.state.playListIdx !== -1 ? styles.smallIconSel : styles.smallIcon}
                onTouchTap={this.touchShowPlayList.bind(this)}
              >
                <AvQueueMusic />
              </IconButton>
              <IconButton
                iconStyle={styles.smallIcon}
                style={styles.small}
                onTouchTap={this.touchShowActionMenu.bind(this)}
              >
                <NavigationMoreVert />
              </IconButton>
            </td>
          </tr></tbody></table>
        </Paper>
        <Popover
          open={this.state.openQueue}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={this.closeQueue.bind(this)}
          animation={PopoverAnimationVertical}
          style={{marginTop:-14}}
        >
          <div style={{maxHeight:400, overflowY:'scroll'}}>
          <List style={{maxWidth:300}}>
             {
               playList.map((mediaObj, idx) => {
                 return (
                  <ListItem
                    leftIcon={<AvPlayCircleOutline color="#000" onTouchTap={this.playMp3FromPlayList.bind(this, mediaObj, idx)} />}
                    rightIcon={<ActionDelete color="#000" onTouchTap={this.deletePlayList.bind(this, mediaObj._id, idx)} />}
                    primaryText={<span style={this.state.playListIdx === idx ? {color:'#FF9800'}: {}}>{mediaObj.title}</span>}
                    secondaryText={mediaObj.authorName}
                    key={'myplaylist' + mediaObj._id}
                  />
                )
              })
            }
          </List>
          </div>
        </Popover>
        <Popover
          open={this.state.adjustVolume}
          anchorEl={this.state.anchorElVol}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={this.closeQueue.bind(this)}
          animation={PopoverAnimationVertical}
          style={{marginTop:-6, zIndex:9999, marginLeft: -5}}
        >
          <div style={{padding:10, paddingTop:0, paddingBottom:15}} >
            <Slider style={{height: 100}} axis="y" defaultValue={0} value={this.state.volume} onDragStop={(event) => this.stopSliderVol(event)} onChange={(event, value) => this.changeSliderVol(event, value)}/>
          </div>
        </Popover>
        <Popover
          open={this.state.actionMenu}
          anchorEl={this.state.anchorElAct}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={this.closeQueue.bind(this)}
          animation={PopoverAnimationVertical}
          style={{marginTop:-11, zIndex:9999, marginLeft: -5}}
        >
          <div style={{padding:0}} >
            <div style={{padding:5, borderBottom:'1px solid #CCCCCC'}}>
              <IconButton
                onTouchTap={this.state.mp3PlayingObj ? this.touchLike.bind(this, this.state.mp3PlayingObj._id) : () => {}}
                iconStyle={this.state.mp3PlayingObj && this.props.myLikes[this.state.mp3PlayingObj._id] ? styles.smallIconSel : styles.smallIcon}
                style={styles.small}
              >
                <ActionFavoriteBorder />
              </IconButton>
            </div>
            <div style={{padding:5, borderBottom:'1px solid #CCCCCC'}}>
              <IconButton
                onTouchTap={this.state.mp3PlayingObj ? this.touchAddPlaylist.bind(this, this.state.mp3PlayingObj) : () => {}}
                iconStyle={this.state.mp3PlayingObj && this.props.myPlayList[this.state.mp3PlayingObj._id] ? styles.smallIconSel : styles.smallIcon}
                style={styles.small}
              >
                <AvPlayListAdd />
              </IconButton>
            </div>
            <div style={{padding:12, borderBottom:'1px solid #CCCCCC', paddingLeft:12}}>
              <FacebookShareButton url={shareUrl} disabled={shareUrl === ''}>
                <FacebookIcon size={25} round />
              </FacebookShareButton>
            </div>
            <div style={{padding:5, borderBottom:'1px solid #CCCCCC'}}>
              <IconButton 
                onClick={this.copyLink.bind(this, shareUrl)} style={styles.small} disabled={shareUrl === ''}
              >
                <ContentLink />
              </IconButton>
            </div>
            <div style={{padding:5, borderBottom:'1px solid #CCCCCC'}}>
                <IconButton onClick={this.mobileOpenQR.bind(this, this.state.mp3PlayingObj, shareUrl)} disabled={shareUrl === ''} iconStyle={shareUrl === '' ? {opacity: 0.5} : {opacity: 1} }>
                  <QRCode size={25} value="dhamma" />
                </IconButton>
            </div>
          </div>
        </Popover>
      </div>
    )
  }

  mediaViewPC() {
    var playList = this.getPlayListArray();
    var playListSize = playList.length;
    var shareUrl = '';
    if (this.state.mp3PlayingObj)
      shareUrl = window.location.hostname + 'index.html?q=' + this.state.mp3PlayingObj._id;
    return (
      <div style={{'position':'fixed', 'bottom':'0px', 'left':'50%', 'width':'860px', 'marginLeft':'-430px', 'zIndex':1499, borderTop: '1px solid #f0ece6'}}>
        <Paper zDepth={0} transitionEnabled={false}>
          <table><tbody><tr>
            <td>
              <IconButton
                iconStyle={styles.mediumIcon}
                style={styles.medium}
                onTouchTap={this.previousMp3.bind(this)}
              >
                <AvSkipPrevious />
              </IconButton>
              <IconButton
                iconStyle={styles.largeIcon}
                style={styles.large}
                onTouchTap={this.touchPPButton.bind(this)}
              >
                { this.state.mediaPlaying ? <AvPause /> : <AvPlayArrow /> }
              </IconButton>
              <IconButton
                iconStyle={styles.mediumIcon}
                style={styles.medium}
                onTouchTap={this.nextMp3.bind(this)}
              >
                <AvSkipNext />
              </IconButton>
            </td>
            <td>
              <div style={{position:'absolute', marginLeft:'17px', width:'320px', marginTop:'8px', textOverflow: 'ellipsis', whiteSpace:'nowrap', overflow:'hidden', animation: 'marquee 15s linear infinite'}}>{this.state.title}</div>
              <table style={{height:'20px', width:'320px', marginTop:'15px'}}><tbody><tr>
                <td><Slider defaultValue={0} value={this.state.progress / 100} onDragStop={(event) => this.stopSlider(event)} onChange={(event, value) => this.changeSlider(event, value)} style={{height:'20px', width:'200px', marginLeft:'20px', marginRight:'10px', marginBottom:'5px'}}/></td>
                <td><span style={{fontSize:12}}>{this.state.currentTime} / {this.state.durationTime}</span></td>
              </tr></tbody></table>
            </td>
            <td>
              {
                this.state.volume !== 0 ?
                <IconButton
                  iconStyle={styles.smallIcon}
                  onTouchTap={this.touchShowAdjustVolume.bind(this)}
                >
                  <AvVolumeUp />
                </IconButton> :
                <IconButton
                  iconStyle={styles.smallIcon}
                  onTouchTap={this.touchShowAdjustVolume.bind(this)}
                >
                  <AvVolumeMute />
                </IconButton>
              }
              {
                playListSize !== 0 ?
                <Badge
                  badgeContent={playListSize}
                  badgeStyle={{fontSize: 12, backgroundColor:'#FF9800', color:'#FFF'}}
                  style={{position:'absolute', marginLeft:25, marginTop:5}}
                /> :
                <span></span>
              }
              <IconButton
                iconStyle={this.state.playListIdx !== -1 ? styles.smallIconSel : styles.smallIcon}
                onTouchTap={this.touchShowPlayList.bind(this)}
              >
                <AvQueueMusic />
              </IconButton>
              &nbsp;&nbsp;
              <IconButton
                onTouchTap={this.state.mp3PlayingObj ? this.touchLike.bind(this, this.state.mp3PlayingObj._id) : () => {}}
                iconStyle={this.state.mp3PlayingObj && this.props.myLikes[this.state.mp3PlayingObj._id] ? styles.smallIconSel : styles.smallIcon}
                style={styles.small}
              >
                <ActionFavoriteBorder />
              </IconButton>

              <IconButton
                onTouchTap={this.state.mp3PlayingObj ? this.touchAddPlaylist.bind(this, this.state.mp3PlayingObj) : () => {}}
                iconStyle={this.state.mp3PlayingObj && this.props.myPlayList[this.state.mp3PlayingObj._id] ? styles.smallIconSel : styles.smallIcon}
                style={styles.small}
              >
                <AvPlayListAdd />
              </IconButton>
            </td>
            <td>
              <div style={{marginLeft:8}}>
                <FacebookShareButton url={shareUrl} disabled={shareUrl === ''}>
                  <FacebookIcon size={25} round />
                </FacebookShareButton>
              </div>
            </td>
            <td>
              <div style={{marginLeft:8}}>
                <IconButton onClick={this.copyLink.bind(this, shareUrl)} iconStyle={styles.smallIcon} disabled={shareUrl === ''}>
                  <ContentLink />
                </IconButton>
              </div>
            </td>
            <td>
              <div style={{marginLeft:2}}>
                <IconButton onClick={this.props.parent.openQRDialog.bind(this.props.parent, this.state.mp3PlayingObj, shareUrl)} disabled={shareUrl === ''} iconStyle={shareUrl === '' ? {opacity: 0.5} : {opacity: 1} }>
                  <QRCode size={25} value="dhamma" />
                </IconButton>
              </div>
            </td>
          </tr></tbody></table>
        </Paper>
        <Popover
          open={this.state.openQueue}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={this.closeQueue.bind(this)}
          animation={PopoverAnimationVertical}
          style={{marginTop:-14}}
        >
          <div style={{maxHeight:400, overflowY:'scroll'}}>
          <List style={{maxWidth:500}}>
             {
               playList.map((mediaObj, idx) => {
                 return (
                  <ListItem
                    leftIcon={<AvPlayCircleOutline color="#000" onTouchTap={this.playMp3FromPlayList.bind(this, mediaObj, idx)} />}
                    rightIcon={<ActionDelete color="#000" onTouchTap={this.deletePlayList.bind(this, mediaObj._id, idx)} />}
                    primaryText={<span style={this.state.playListIdx === idx ? {color:'#FF9800'}: {}}>{mediaObj.title}</span>}
                    secondaryText={mediaObj.authorName}
                    key={'myplaylist' + mediaObj._id}
                  />
                )
              })
            }
          </List>
          </div>
        </Popover>
        <Popover
          open={this.state.adjustVolume}
          anchorEl={this.state.anchorElVol}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={this.closeQueue.bind(this)}
          animation={PopoverAnimationVertical}
          style={{marginTop:-16, zIndex:9999, marginLeft: -5}}
        >
          <div style={{padding:10, paddingTop:0, paddingBottom:15}} >
            <Slider style={{height: 100}} axis="y" defaultValue={0} value={this.state.volume} onDragStop={(event) => this.stopSliderVol(event)} onChange={(event, value) => this.changeSliderVol(event, value)}/>
          </div>
        </Popover>
      </div>
    )
  }

  render() {
    if (Common.isMobile()) {
      return this.mediaViewMobile()
    }
    else {
      return this.mediaViewPC();
    }
  }
}

export default MediaControl;



// WEBPACK FOOTER //
// ./src/MediaControl.js